import React from 'react';
import { IssueAssignee } from '@momentum/types';
import { UserSelectorAvatar } from '@/shared/components/user-selector/UserSelectorAvatar';

interface TaskAssigneesProps {
  assignees: IssueAssignee[];
  maxVisible?: number;
}

export const TaskAssignees: React.FC<TaskAssigneesProps> = ({
  assignees,
  maxVisible = 3,
}) => {
  const visibleAssignees = assignees.slice(0, maxVisible);
  const remainingCount = assignees.length - maxVisible;

  if (assignees.length === 0) {
    return <span className="text-xs text-gray-400">—</span>;
  }

  return (
    <div className="flex -space-x-2">
      {visibleAssignees.map((assignee) => {
        if (!assignee?.personalInfo) return null;

        return (
          <UserSelectorAvatar
            key={assignee._id}
            fullName={`${assignee.personalInfo.firstName} ${assignee.personalInfo.lastName}`}
            imageUrl={assignee.personalInfo.imageUrl}
            size="md"
            variant="neutral"
            className="ring-2 ring-white"
          />
        );
      })}
      {remainingCount > 0 && (
        <div className="w-5 h-5 rounded-full bg-gray-300 border-2 border-white flex items-center justify-center">
          <span className="text-[9px] font-semibold text-gray-600">
            +{remainingCount}
          </span>
        </div>
      )}
    </div>
  );
};
